import { createContext, useContext, type ReactNode } from 'react'

const Ds2026ButtonContext = createContext(false)

export const useDs2026Buttons = () => useContext(Ds2026ButtonContext)

/**
 * Opts a subtree into the DS2026 button look. FbButton reads this context and
 * swaps its primary / outline / secondary variants to the DS2026 tokens
 * (brighter Basil-600 primary with a Basil-700 hover, white/Gray-300 outline).
 * Default chrome elsewhere in the app is untouched.
 */
export const Ds2026ButtonProvider = ({ children }: { children: ReactNode }) => (
  <Ds2026ButtonContext.Provider value={true}>
    {children}
  </Ds2026ButtonContext.Provider>
)
